import React, { Component } from 'react';

export default class SideBarMenu extends Component {

    constructor(props) {
        super(props);

        this.state = {
            style  : {
                width : 0
            }
        };

        this.openNav  = this.openNav.bind(this);
        this.closeNav = this.closeNav.bind(this);
    }

    componentDidMount() {
        document.addEventListener("click", this.closeNav);
    }

    componentWillUnmount() {
        document.removeEventListener("click", this.closeNav);
    }

    openNav() {

        let style = { width : 350 };
        this.setState({style});
        // document.body.style.backgroundColor = "rgba(0,0,0,0.4)";
        document.addEventListener("click", this.closeNav);
    }

    closeNav() {

        document.removeEventListener("click", this.closeNav);
        let style = { width : 0 };
        this.setState({style});
        // document.body.style.backgroundColor = "#F3F3F3";
    }

    render() {
        return (
            <div id = "mySidenav" ref="snav" className = "sidenav" style={this.state.style}>
                <div className="sidenav-container">
                    <div className="text-center">
                        <h3>{this.props.bName}</h3>
                        <p> Choose location </p>
                    </div>
                  <a href = "javascript:void(0)" className = "closebtn" onClick = {this.closeNav}>×</a>
                  <div className="list-group">
                      {this.props.children}
                  </div>
                </div>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// src/components/dashboard/sidebar/sidebar-menu.js